module.exports = __webpack_public_path__ + "img/Balance-4-mobile.5f22e27d.jpg";